import { COLORS } from "../../theme/colors";

export const CARBON_REVENUES_LEGENDS = {
  ALLOWANCES_TRADING: "allowances_trading",
  VOLUNTERY_CREDITS: "voluntery_credits",
  OFFSET_CREDITS: "offset_credits",
};

export const CARBON_REVENUES_COLORS = {
  [CARBON_REVENUES_LEGENDS.ALLOWANCES_TRADING]: "#349E88",
  [CARBON_REVENUES_LEGENDS.VOLUNTERY_CREDITS]: "#A2F8A9",
  [CARBON_REVENUES_LEGENDS.OFFSET_CREDITS]: "#4EE3C5",
};

export const SAVE_THE_PLANET_LEGENDS = {
  TRADING: "trading",
  BATTERY: "battery",
  EV: "ev",
};

export const SAVE_THE_PLANET_COLORS = {
  [SAVE_THE_PLANET_LEGENDS.TRADING]: COLORS.purple,
  [SAVE_THE_PLANET_LEGENDS.BATTERY]: "#4F31CF",
  [SAVE_THE_PLANET_LEGENDS.EV]: COLORS.cian,
};
